import { message, Modal } from "antd";

import { useDownloadAppliedInnovationsMutation } from "features/documentCenter/documentCenterAPI";

function DownloadAppliedInnovationsModal({ open, onOk, onCancel }) {
  const [downloadAppliedInnovations, { isLoading: isAppliedInnovationsDownloading }] =
    useDownloadAppliedInnovationsMutation();

  const onSubmit = async () => {
    const result = await downloadAppliedInnovations();
    if ("data" in result) {
      await onOk();
      return message.success(
        "Applied Innovation file is being generated. Please check back later in the Generated Documents section.",
      );
    }
  };

  return (
    <Modal
      maskClosable={false}
      title="Download Applied Innovation export"
      open={open}
      onOk={onSubmit}
      onCancel={onCancel}
      okButtonProps={{
        loading: isAppliedInnovationsDownloading,
      }}
      confirmLoading={isAppliedInnovationsDownloading}
    >
      <p>This file will be generated during night time.</p>
    </Modal>
  );
}

export default DownloadAppliedInnovationsModal;
